import { PortfolioItems } from "@pages/Profile/components/Balance";

export const calculateSectorPath = (sortedPortfolioItems: PortfolioItems[], index: number, radius: number) => {
    const total = sortedPortfolioItems.reduce((acc, item) => {
        if (item.count == 0) return acc;
        return acc + item.tonPrice;
    }, 0);
    const startAngle =
        index === 0
            ? 0
            : sortedPortfolioItems.slice(0, index).reduce((acc, item) => {
                  if (item.count == 0) return acc;
                  return acc + (item.tonPrice / total) * 180;
              }, 0);
    const angle = (sortedPortfolioItems[index].tonPrice / total) * 180;

    const startAngleCorrected = startAngle + 180;
    const angleCorrected = angle;

    const x1 = 100 + radius * Math.cos((startAngleCorrected * Math.PI) / 180);
    const y1 = 100 + radius * Math.sin((startAngleCorrected * Math.PI) / 180);
    const x2 = 100 + radius * Math.cos(((startAngleCorrected + angleCorrected) * Math.PI) / 180);
    const y2 = 100 + radius * Math.sin(((startAngleCorrected + angleCorrected) * Math.PI) / 180);

    const largeArcFlag = angleCorrected > 180 ? 1 : 0;

    return `M 100 100 L ${x1} ${y1} A ${radius} ${radius} 0 ${largeArcFlag} 1 ${x2} ${y2} Z`;
};
